import { urlBase64ToUint8Array } from "./pushNotificationHelpers";
import { LogbogPushNotificationApi } from "services/api/logbogPushNotification/logbogPushNotificationApi";

export const subscribeForPushNotifications = async (pushNotificationApi: LogbogPushNotificationApi, registration: ServiceWorkerRegistration): Promise<PushSubscription | undefined> => {
  const vapidPublicKey = await pushNotificationApi.getVapidPublicKey();

  const applicationServerPublicKey = urlBase64ToUint8Array(vapidPublicKey);

  const pushSubscriptionOptions: PushSubscriptionOptionsInit = {
    userVisibleOnly: true,
    applicationServerKey: applicationServerPublicKey
  };

  const existingSubscription = await registration.pushManager.getSubscription();
  const subscription = existingSubscription ?? await registration.pushManager.subscribe(pushSubscriptionOptions);
  
  try {
    const response = await pushNotificationApi.registerSubscription(subscription);
    if (!response) {
      console.warn("Failed to subscribe to Push Notifications on server")
      return undefined;
    }
    return subscription;

  } catch (e) {
    console.error("Failed to subscribe to Push Notifications on server with error", e)
    return undefined;
  }
};

export const unsubscribeFromPushNotifications = async (pushNotificationApi: LogbogPushNotificationApi, registration: ServiceWorkerRegistration): Promise<boolean> => {
  const subscription = await registration.pushManager.getSubscription();

  if(!subscription) {
    console.warn("Failed to unsubscribe - subscription is not defined");
    return false;
  }

  await subscription.unsubscribe();
  
  try {
    const response = await pushNotificationApi.unregisterSubscription(subscription);
    if (!response) {
      console.warn("Failed to unsubscribe from Push Notifications on server")
    }
    return response;
    
  } catch (e) {
    console.error("Failed to unsubscribe from Push Notifications on server with error", e)
    return false;
  }
};
